var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase, ReactElementFactory } from "survey-react-ui";
var SideBarHeader = /** @class */ (function (_super) {
    __extends(SideBarHeader, _super);
    function SideBarHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SideBarHeader.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SideBarHeader.prototype.getStateElement = function () {
        return this.model;
    };
    SideBarHeader.prototype.renderElement = function () {
        return (React.createElement("div", { className: "svc-side-bar__container-header svc-sidebar__header-container" }, (this.model.subTitle) ?
            React.createElement("div", { className: "svc-sidebar__header-caption" },
                React.createElement("span", { className: "svc-sidebar__header-title" }, this.model.title),
                React.createElement("span", { className: "svc-sidebar__header-subtitle" }, this.model.subTitle))
            : React.createElement("div", { className: "svc-side-bar__container-title" }, this.model.title)));
    };
    return SideBarHeader;
}(SurveyElementBase));
ReactElementFactory.Instance.registerElement("svc-side-bar-header", function (props) {
    return React.createElement(SideBarHeader, props);
});
